import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import AppBaqueiraHeader from '../containers/AppBaqueiraHeader'
import { withNamespaces } from "react-i18next";
import StepBarBaqueira from '../components/StepBarBaqueira'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { putUpdatePrerental } from '../actions/qrsbaqueira'

class PhoneBaqueiraView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
      phoneNumber: '',
      mail: '',
      zona: '1',
      accesible: 'NO',
      confirmReservation: false,
      newsletterAcceptance: false,
      qrsale: null,
      booking: null,
      lockerSelected: null,
      lockerPrice: null,
      descriptionZone: null,
      selectedAccessibility: null,
      zoneSelected: null,
      selectedLocker: null,
      lockerAssigned: null,
      lockerPrice: null,
      paymentId: null,
      qrToken: null,
      lockerPin: null,
      lockerMatricula: null,
      lockerCustomer: null,
      lockerInvoice: null,
      qrType: "pay",
      qrMode: 0,
      customerName: '',
      language: null,
      startDate: null,
      endDate: null,
    }

    this.toggle = this.toggle.bind(this);
    this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
    this.handleMailChange = this.handleMailChange.bind(this);
    this.handleCustomerNameChange = this.handleCustomerNameChange.bind(this);
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  handlePhoneNumberChange(value, countryData) {
    let cleaned = value;

    if (countryData && countryData.dialCode) {
      const dc = countryData.dialCode;
      cleaned = cleaned.replace(/^\+/, '');

      // Strip duplicated prefix (e.g. "3434612345678" → "34612345678")
      if (cleaned.startsWith(dc) && cleaned.slice(dc.length).startsWith(dc)) {
        cleaned = cleaned.slice(dc.length);
      }

      // Handle pasted "00" international prefix
      const afterDc = cleaned.slice(dc.length);
      if (afterDc.startsWith('00' + dc)) {
        cleaned = dc + afterDc.slice(('00' + dc).length);
      }

      cleaned = cleaned.replace(/[^\d]/g, '');
    }

    this.setState({ phoneNumber: cleaned });
  }

  // Utility function to remove accents
  removeAccents(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  // Updated method
  handleCustomerNameChange(event) {
    const customerName = this.removeAccents(event.target.value);
    this.setState({ customerName });
  }

  handleMailChange(event) {
    const mail = event.target.value;
    const isValidEmail = this.validateEmail(mail);
    this.setState({ mail, isValidEmail });
  }

  validateEmail(email) {
    // A simple email validation pattern using regular expression
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  goTo(e) {
    const {
      zoneSelected,
      descriptionZone,
      selectedLocker,
      lockerPrice,
      lockerAssigned,
      prerentCode,
      prerentTime,
      totalDays,
      startDate,
      endDate,
      qrType,
      qr,
      timeStamp
    } = this.props.location.state;

    if (!this.isContinueDisabled()) {

      this.props.putUpdatePrerental(prerentCode, {
        PrerentName: this.state.customerName,
        PrerentPhone: this.state.phoneNumber,
        PrerentEmail: this.state.mail,
      });

      this.props.push('/PaymentBaqueiraView', {
        // PASSED VARS
        zoneSelected: zoneSelected,
        descriptionZone: descriptionZone,
        selectedLocker: selectedLocker,
        lockerPrice: lockerPrice,
        lockerAssigned: lockerAssigned,
        prerentCode: prerentCode,
        prerentTime: prerentTime,
        totalDays: totalDays,
        startDate: startDate,
        endDate: endDate,
        qrType: qrType,
        qr: qr,
        timeStamp: timeStamp,
        // PHONE VARS
        customerName: this.state.customerName,
        phoneNumber: this.state.phoneNumber,
        mail: this.state.mail,
        newsletterAcceptance: this.state.newsletterAcceptance,
        confirmReservation: this.state.confirmReservation,
      });
    }
  }

  componentDidMount() {

  }

  isContinueDisabled() {

    const disabled = ((this.state.phoneNumber.length < 6) || !this.state.isValidEmail || !this.state.confirmReservation || this.state.customerName.length == 0);

    return disabled;
  }

    getLockerType(type) {
    const { t, i18n } = this.props

    switch (type) {
      case "BNS":
        return 'STANDARD'
      case "CNS":
        return 'STANDARD CARGA'
      case "BWS":
        return 'STANDARD XL'
      case "CWS":
        return 'STANDARD CARGA XL'
      case "BNM":
        return 'MEDIUM'
      case "CNM":
        return 'MEDIUM CARGA'
      case "BWM":
        return 'MEDIUM XL'
      case "CWM":
        return 'MEDIUM CARGA XL'
      case "BNL":
        return 'LARGE'
      case "CNL":
        return 'LARGE CARGA'
      case "BWL":
        return 'LARGE XL'
      case "CWL":
        return 'LARGE CARGA XL'
      case "BNXL":
        return 'LARGE'
      case "CNXL":
        return 'LARGE CARGA'
      case "BWXL":
        return 'LARGE XL'
      case "CWXL":
        return 'LARGE CARGA XL'
      case "BN2XL":
        return 'LARGE'
      case "CN2XL":
        return 'LARGE CARGA'
      case "BW2XL":
        return 'LARGE XL'
      case "CW2XL":
        return 'LARGE CARGA XL'
      case "BN3XL":
        return t('2 Equipos de esquí')
      case "CN3XL":
        return t('3 Equipos de esquí')
      case "BW3XL":
        return t('4 Equipos de esquí')
      case "CW3XL":
        return t('SKI CARGA XL')
      default:
        return 'STANDARD'
    }
  }

  renderSelectedInfo() {
    const { zoneSelected, descriptionZone, selectedQuantity, selectedLocker, startDate, endDate } = this.props.location.state;
    const { t } = this.props;

    return (
      <div>
        <p className="lockTitleBaqueira">
          <span className="text-vw-light-baqueira">{t("ZONA")}: </span>
          <span className="text-vw-dark-baqueira">{zoneSelected} - {descriptionZone}</span>
        </p>
        <p className="lockTitleBaqueira">
          <span className="text-vw-light-baqueira">{t("TIPO")}: </span>
          <span className="text-vw-dark-baqueira">{this.getLockerType(selectedLocker)}</span>
        </p>
        <p className="lockTitleBaqueira">
          <span className="text-vw-light-baqueira">{t("CANTIDAD")}: </span>
          <span className="text-vw-dark-baqueira">{selectedQuantity}</span>
        </p>
        <p className="lockTitleBaqueira">
          <span className="text-vw-light-baqueira">{t("FECHAS")}: </span>
          <span className="text-vw-dark-baqueira">{startDate ? startDate.toLocaleDateString() : ""} - {endDate ? endDate.toLocaleDateString() : ""}</span>
        </p>
      </div>
    );
  }

  render() {
    const { t, i18n } = this.props;

    return (
      <div>
        <AppBaqueiraHeader />
        <div className="lockerContainer smartphone">
          <br></br>
          <StepBarBaqueira step={3} />
          <br></br>
          <h3 className="lockTitle">
            <span className="text-vw-dark-baqueira">{t('FACILITANOS TUS DATOS DE RESPALDO')}</span>
          </h3>
          <div className="lockTitle">
            <span className="text-vw-dark-baqueira">{t('Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin de esta en caso de que lo pierdas. Al email te llegará la confirmación de tu reserva.')}</span>
          </div>
          <div>
            <br></br>
            <h3 className="lockTitle">
              <span className="text-vw-dark-baqueira">{t('NOMBRE COMPLETO*')}</span>
            </h3>
            <input className="phoneInput"
              name="name"
              type="text"
              value={this.state.customerName}
              onChange={this.handleCustomerNameChange}
            />
            <br></br>
            <h3 className="lockTitle">
              <span className="text-vw-dark-baqueira">{t('TELÉFONO*')}</span>
            </h3>
            <PhoneInput
              country="es" // default country code
              value={this.state.phoneNumber}
              onChange={this.handlePhoneNumberChange}
              inputClass="phoneInput" // style to match form
              pattern="[0-9]*"
              countryCodeEditable={false}
            />
            <br></br>
            <h3 className="lockTitle">
              <span className="text-vw-dark-baqueira">{t('EMAIL*')}</span>
            </h3>
            <input className="phoneInput"
              name="lockerEmail"
              type="text"
              value={this.state.mail}
              onChange={this.handleMailChange}
              autoCapitalize='none'
            />
            <br></br>
            <br></br>
            <div className="text-center">
              <a
                href="https://www.baqueira.es/condiciones-compra-y-uso-lockers"
                target="_blank"
                rel="noopener noreferrer"
                className="terms-link"
              >
                {t('Leer términos y condiciones.')}
              </a>
            </div>
            <br></br>
            <div className='divCheckbox'>
              <input
                type="checkbox"
                id="confirmReservation"
                name="confirmReservation"
                checked={this.state.confirmReservation}
                onChange={() => this.setState({ confirmReservation: !this.state.confirmReservation })}
              />
              <div className="slider-baqueira"></div>
              <label htmlFor="confirmReservation" className='textcheckbox-baqueira slide-checkbox'>
                {t('Confirmo que he leído y acepto los términos y condiciones de uso del servicio.')}
              </label>
            </div>
            {/* <div className='divCheckbox'>
              <input
                type="checkbox"
                id="newsletterAcceptance"
                name="newsletterAcceptance"
                checked={this.state.newsletterAcceptance}
                onChange={() => this.setState({ newsletterAcceptance: !this.state.newsletterAcceptance })}
              />
              <div className="slider-baqueira"></div>
              <label htmlFor="newsletterAcceptance" className='textcheckbox-baqueira slide-checkbox'>
                {t('Acepto suscribirme al boletín informativo de Baqueira Beret para recibir contenido y notificaciones comerciales.')}

              </label>
            </div> */}
          </div>
          <div className="row">
            <div
              className={`col lockerContinueButtonBaqueira ${this.isContinueDisabled() ? "disabled" : ""}`}
              onClick={(e) => this.goTo(1, e)}
            >
              <h1>{t("CONTINUAR")}</h1>
            </div>
          </div>
          <br></br>
          <div className="lockTitle">
            <span className="text-vw-dark-baqueira">{t('*Los datos personales recabados no se usarán en ningún caso para ofrecer comunicados comerciales de ningún tipo si el cliente no se suscribe a la newsletter.')}</span>
          </div>
        </div>

        <div className="lockerContainer pc">
          <br></br>
          <StepBarBaqueira step={3} />
          <hr class="bg-vw-light"></hr>
          <br></br>
          <div className="row">
            <div className="col-3" style={{ borderRadius: "10px", backgroundColor: "#ededed" }}>
              <h3 className="lockTitle">
                <span className="text-vw-dark-baqueira">{t('RESUMEN')}</span>
              </h3>
              <br></br>
              {this.renderSelectedInfo()}
              <br />
            </div>
            <div className="col-1"></div>
            <div className="col-8">
              <h3 className="lockTitle">
                <span className="text-vw-dark">{t('FACILITANOS TUS DATOS DE RESPALDO')}</span>
              </h3>
              <div className="lockTitle">
                <span className="text-vw-dark">{t('Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin de esta en caso de que lo pierdas. Al email te llegará la confirmación de tu reserva.')}</span>
              </div>
              <br></br>
              <div className="d-flex">
                <div className="col">
                  <br></br>
                  <h3 className="lockTitle">
                    <span className="text-vw-dark-baqueira">{t('NOMBRE COMPLETO*')}</span>
                  </h3>
                  <input className="phoneInput"
                    name="name"
                    type="text"
                    value={this.state.customerName}
                    onChange={this.handleCustomerNameChange}
                  />
                  <br></br>
                  <h3 className="lockTitle">
                    <span className="text-vw-dark-baqueira">{t('TELÉFONO*')}</span>
                  </h3>
                  <PhoneInput
                    country="es" // default country code
                    value={this.state.phoneNumber}
                    onChange={this.handlePhoneNumberChange}
                    inputClass="phoneInput" // style to match form
                    pattern="[0-9]*"
                    countryCodeEditable={false}
                  />
                  <br></br>
                </div>
                <div className="col">
                  <br></br>
                  <h3 className="lockTitle">
                    <span className="text-vw-dark-baqueira">{t('EMAIL*')}</span>
                  </h3>
                  <input className="phoneInput"
                    name="lockerEmail"
                    type="text"
                    value={this.state.mail}
                    onChange={this.handleMailChange}
                    autoCapitalize='none'
                  />
                  <br></br>
                  <br></br>
                  <div className="text-center">
                    <a
                      href="https://www.baqueira.es/condiciones-compra-y-uso-lockers"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="terms-link"
                    >
                      {t('Leer términos y condiciones.')}
                    </a>
                  </div>
                  <br></br>
                  <div className='divCheckbox'>
                    <input
                      type="checkbox"
                      id="confirmReservation"
                      name="confirmReservation"
                      checked={this.state.confirmReservation}
                      onChange={() => this.setState({ confirmReservation: !this.state.confirmReservation })}
                    />
                    <div className="slider-baqueira"></div>
                    <label htmlFor="confirmReservation" className='textcheckbox-baqueira slide-checkbox'>
                      {t('Confirmo que he leído y acepto los términos y condiciones de uso del servicio.')}
                    </label>
                  </div>
                </div>
              </div>
              <br></br>
              <div className="row">
                <div
                  className={`col lockerContinueButtonBaqueira ${this.isContinueDisabled() ? "disabled" : ""}`}
                  onClick={(e) => this.goTo(1, e)}
                >
                  <h1>{t("CONTINUAR")}</h1>
                </div>
              </div>
              <br></br>
              <div className="lockTitle">
                <span className="text-vw-dark-baqueira">{t('*Los datos personales recabados no se usarán en ningún caso para ofrecer comunicados comerciales de ningún tipo si el cliente no se suscribe a la newsletter.')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: true
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  putUpdatePrerental: bindActionCreators(putUpdatePrerental, dispatch)
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(PhoneBaqueiraView));
